import { useState } from 'react'

export const useSideNav = () => {
  const [opened, setOpened] = useState(true)
  return {
    opened,
    setOpened,
  }
}
